import styled, { css } from 'styled-components'
import { Colors, Shadows } from 'cio-design-library/design-tokens'

import Media from 'builder/styles/media'
import { SpinnerBlack } from 'builder/components/Spinner'
import { TemplatesList } from 'builder/components/TemplatesList/TemplatesList'
import { TemplateName, TemplatePreview } from 'builder/components/TemplatesList/styles'
import { ButtonSize, ButtonTheme, ButtonV2 } from 'builder/components/Button'
import {
  Template,
  Templates as TemplatesComponent,
  TemplatePreview as TemplatePreviewComponent,
} from 'builder/components/DocumentCustomizationModal/components/ResumeSidebar/components/TemplateSelectionMobile/styles'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  ${Media.Tablet`
    gap: 20px;
  `}

  ${Media.Phone`
    gap: 12px;  
  `}
`

export const LoaderContainer = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Loader = styled(SpinnerBlack)`
  width: 24px;
  height: 24px;
`

export const TemplatesListComponent = styled(TemplatesList)`
  width: 100%;

  ${TemplateName} {
    margin-bottom: 8px;
    color: ${Colors.Neutral80};
  }

  ${TemplatePreview} {
    box-shadow: 0 0 1px 0 rgba(15, 56, 113, 0.32), 0 1px 2px 0 rgba(15, 56, 113, 0.12),
      0 2px 4px 0 rgba(15, 56, 113, 0.08);
  }
`

export const TemplateListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
`

export const TemplateCategories = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;

  ${Media.Phone`
    display: block;
    padding: 8px 0;
  `}

  & .swiper-wrapper {
    display: flex;
    position: relative;
  }
`

export const TemplateCategory = styled(ButtonV2).attrs({
  size: ButtonSize.small,
  theme: ButtonTheme.ghost,
})<{ isActive: boolean }>`
  width: fit-content;
  padding: 8px 16px;
  border-radius: 24px;

  ${Media.Phone`
    padding: 8px 12px;

    span {
      min-height: unset;
    }
  `}

  ${({ isActive }) =>
    isActive &&
    css`
      color: ${Colors.Blue50};
      background-color: ${Colors.Blue10};
      box-shadow: ${Colors.Blue50} 0px 0px 0px 1px inset;
    `}
`

export const TemplateMobile = styled(Template)`
  color: ${Colors.Neutral50};

  .swiper-slide-active & {
    color: ${Colors.Neutral90};
  }
`

export const TemplatesMobile = styled(TemplatesComponent)`
  gap: 8px;
`

export const TemplatePreviewMobile = styled(TemplatePreviewComponent)`
  box-shadow: ${Shadows.lightWithBorderShadowMid};
`
